import types from './mutation-types'
import Vue from 'vue'

export default {
  [types.FETCH_TASK_TYPES] (state, taskTypes) {
    taskTypes.forEach(taskType => {
      Vue.set(state.taskTypes, taskType.id, taskType)
    })
  },

  [types.FETCH_TASK_GROUPS] (state, taskGroups) {
    taskGroups.forEach(taskGroup => {
      Vue.set(state.taskGroups, taskGroup.id, taskGroup)
    })
  },

  [types.FETCH_TASK_OPERATIONS] (state, taskOperations) {
    taskOperations.forEach((taskOperation, index) => {
      Vue.set(state.taskOperations, index, taskOperation)
    })
  },

  [types.CREATE_TASK_GROUP] (state, taskGroup) {
    state.recentlyCreatedTaskGroups[taskGroup.id] = taskGroup
    Vue.set(state.taskGroups, taskGroup.id, taskGroup)
  },

  [types.CLEAR] (state) {
    state.taskTypes = {}
    state.taskGroups = {}
    state.taskOperations = []
    state.recentlyCreatedTaskGroups = {}
    state.surveyTasks = []
  }
}
